import { Header } from '@almbrand/header';
import { useDeviceQuery } from '@almbrand/usedevicequery';
import { ThemeNames } from 'constantsValues';
import { PageContext } from 'context/PageContext';
import { useContext } from 'react';
import { NavLink } from 'react-router-dom';

export const HeaderComponent: React.FC<HeaderReference> = ({
	logoImage,
	logoDarkImage,
	logoUrl,
	loginLabelText,
	loginUrl,
	headerLinks,
	showLoginButton,
}) => {
	const pageContext = useContext(PageContext);
	const { theme } = pageContext ?? {};
	const themeName = ThemeNames[theme];
	const { isMobile } = useDeviceQuery();

	const mapNavigationLinks = (links: Link[]) =>
		links
			.map((link) => ({
				text: link?.text ?? '',
				title: link?.title ?? '',
				url: link?.url ?? '',
				target: link?.target ?? '',
				isExternalLink: link?.isExternalLink ?? false,
				useVueRoute: link?.useVueRoute ?? false,
			}))
			.filter((link) => link.text && link.url);

	return (
		<Header
			logoProps={{ logoUrl: logoImage?.url ?? '', link: logoUrl?.url ?? '/' }}
			navigationLinks={headerLinks?.length > 0 && mapNavigationLinks(headerLinks)}
			buttonProps={
				showLoginButton && {
					buttonType: 'personal',
					children: loginLabelText ?? 'Login',
					size: 'small',
					iconProps: isMobile
						? {
								themeName,
								icon: 'lock',
								width: '24',
							}
						: undefined,
					linkButtonSettings: {
						href: loginUrl?.url ?? '/auth/login',
						target: loginUrl?.target ?? '_self',
					},
				}
			}
			renderChildren={(link): JSX.Element => (
				<NavLink
					key={link?.url}
					to={link?.url}
					title={link?.title}
				>
					{link?.text}
				</NavLink>
			)}
		/>
	);
};
